/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './app.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/router';
import * as import3 from '../../app/app.component';
const styles_AppComponent:any[] = [import0.styles];
export const RenderType_AppComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_AppComponent,
  data: {}
}
);
export function View_AppComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),22,'header',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    Extreme Pingpong\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'info'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'info__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      Author: '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'info__item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      Version: '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'a',[
      [
        'class',
        'info__item'
      ]
      ,
      [
        'target',
        '_blank'
      ]

    ]
      ,[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n      Github\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'content',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(8388608,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(73728,(null as any),0,import2.RouterOutlet,[
      import2.RouterOutletMap,
      import1.ViewContainerRef,
      import1.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(null as any),(ck,v) => {
    var co:import3.AppComponent = v.component;
    const currVal_0:any = co.projectAuthor;
    ck(v,10,0,currVal_0);
    const currVal_1:any = co.projectVersion;
    ck(v,16,0,currVal_1);
    const currVal_2:any = co.githubRepositoryUrl;
    ck(v,19,0,currVal_2);
  });
}
function View_AppComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'ept-root',([] as any[]),(null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
    import1.ɵdid(57344,(null as any),0,import3.AppComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:import1.ComponentFactory<import3.AppComponent> = import1.ɵccf('ept-root',import3.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL1BlZHJvLXZrL2V4dHJlbWUtcGluZ3BvbmctdG91cm5hbWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS90cmF2aXMvYnVpbGQvUGVkcm8tdmsvZXh0cmVtZS1waW5ncG9uZy10b3VybmFtZW50L3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL1BlZHJvLXZrL2V4dHJlbWUtcGluZ3BvbmctdG91cm5hbWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL1BlZHJvLXZrL2V4dHJlbWUtcGluZ3BvbmctdG91cm5hbWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGhlYWRlcj5cbiAgPGgxPlxuICAgIEV4dHJlbWUgUGluZ3BvbmdcbiAgPC9oMT5cbiAgPGRpdiBjbGFzcz1cImluZm9cIj5cbiAgICA8c3BhbiBjbGFzcz1cImluZm9fX2l0ZW1cIj5cbiAgICAgIEF1dGhvcjogPHNwYW4+e3twcm9qZWN0QXV0aG9yfX08L3NwYW4+XG4gICAgPC9zcGFuPlxuICAgIDxzcGFuIGNsYXNzPVwiaW5mb19faXRlbVwiPlxuICAgICAgVmVyc2lvbjogPHNwYW4+e3twcm9qZWN0VmVyc2lvbn19PC9zcGFuPlxuICAgIDwvc3Bhbj5cbiAgICA8YVxuICAgICAgY2xhc3M9XCJpbmZvX19pdGVtXCJcbiAgICAgIHRhcmdldD1cIl9ibGFua1wiXG4gICAgICBbaHJlZl09XCJnaXRodWJSZXBvc2l0b3J5VXJsXCI+XG5cbiAgICAgIEdpdGh1YlxuICAgIDwvYT5cbiAgPC9kaXY+XG48L2hlYWRlcj5cbjxjb250ZW50PlxuICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG48L2NvbnRlbnQ+XG4iLCI8ZXB0LXJvb3Q+PC9lcHQtcm9vdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtJQUFRO0lBQ047SUFBSTtJQUVDO01BQ0w7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFrQjtNQUNoQjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlCO0lBQ2Y7SUFBTTtNQUFBO01BQUE7SUFBQTtJQUFBO0lBQXdCO0lBQ2pDO01BQ1A7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF5QjtJQUNkO0lBQU07TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUF5QjtJQUNuQztJQUNQO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFHK0I7SUFHM0I7SUFDQTtJQUNDO0lBQ1Q7SUFBUztJQUNQO2dCQUFBOzs7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUErQjtJQUN2Qjs7OztJQWhCVTtJQUFBO0lBR0M7SUFBQTtJQUtmO0lBSEYsVUFHRSxTQUhGOzs7OztJQ1hKO2dCQUFBOzs7SUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts